import React from 'react'
import { Route } from "react-router-dom";
import withCreateProtectedPortalRoute from './withCreateProtectedPortalRoute';

const ProtectedPortalRoute = props => (
  <Route
    {...props}
    component={withCreateProtectedPortalRoute(props.component)}
  />
)

export default ProtectedPortalRoute



// WEBPACK FOOTER //
// ./src/components/templates/route-management/ProtectedPortalRoute.js